const topics = [
  { label: '红桃视频精选', icon: 'ri-heart-line', desc: '最新热播剧集与电影', color: 'bg-primary-100 text-primary-700' },
  { label: '樱桃视频热播', icon: 'ri-fire-line', desc: '人气综艺与真人秀', color: 'bg-accent-100 text-accent-700' },
  { label: '茄子视频新番', icon: 'ri-rocket-line', desc: '动漫新番同步更新', color: 'bg-secondary-100 text-secondary-700' },
  { label: '糖心视频剧场', icon: 'ri-movie-line', desc: '独家短剧与微电影', color: 'bg-primary-100 text-primary-700' },
  { label: '榴莲视频影院', icon: 'ri-film-line', desc: '高清大片随时看', color: 'bg-accent-100 text-accent-700' },
  { label: '桃子视频综艺', icon: 'ri-emotion-laugh-line', desc: '热门综艺一网打尽', color: 'bg-secondary-100 text-secondary-700' },
  { label: '热门电视剧场', icon: 'ri-tv-line', desc: '追剧不停歇', color: 'bg-primary-100 text-primary-700' },
  { label: '高清电影专区', icon: 'ri-clapperboard-line', desc: '院线大片高清体验', color: 'bg-accent-100 text-accent-700' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-12 md:py-16 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1200px] mx-auto">
        <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900 text-center mb-2">热门专题</h2>
        <p className="text-sm text-foreground-400 text-center mb-8 md:mb-10">聚合多平台优质内容，分类直达想看就看</p>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
          {topics.map((topic) => (
            <a
              key={topic.label}
              href="#cards"
              className="bg-background-100 hover:bg-background-200 rounded-lg p-4 md:p-5 text-center transition-colors cursor-pointer group"
            >
              <span className={`w-10 h-10 md:w-11 md:h-11 rounded-xl ${topic.color} flex items-center justify-center mx-auto mb-3 transition-transform group-hover:scale-110`}>
                <i className={`${topic.icon} text-base md:text-lg`}></i>
              </span>
              <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-900 mb-1">{topic.label}</h3>
              <p className="text-xs text-foreground-400">{topic.desc}</p>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}